import React from 'react';

import {
  EditSbatGroupInstructorsForm,
  EditSbatGroupLessonForm,
  findLessonByLessonType,
  LESSON_INPUT_OPTIONS,
  LESSON_TYPES,
  PlaylistField,
} from 'features/classCreation';
import DiscussionDateAndTime from '../DiscussionDateAndTime';
import DiscussionSwitch from '../DiscussionSwitch';
import EditableSection from 'components/EditableSection';
import LectureDetails from '../LectureDetails';
import { Tappable } from '@vectord/components';

function Discussion({ sbatGroup }) {
  const { academy_topic: academyTopic } = sbatGroup || {};
  const { lessons, playlist_owner: playlistOwner } = academyTopic || {};
  const discussion = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.liveLecture,
  });

  if (discussion) {
    return (
      <>
        <div className="row align-c dark bold m-b-m">
          Discussion <DiscussionSwitch sbatGroup={sbatGroup} />
        </div>
        <EditableSection
          canEdit
          title="Instructors"
          titleClassName="dark bold"
          className="m-b-s"
        >
          {(editableProps) => (
            <EditSbatGroupInstructorsForm
              {...editableProps}
              sbatGroup={sbatGroup}
            />
          )}
        </EditableSection>
        <DiscussionDateAndTime sbatGroup={sbatGroup} />
        <LectureDetails sbatGroup={sbatGroup} />
        <PlaylistField
          playlistOwner={playlistOwner}
          className="m-b-s"
        />
        <EditableSection
          canEdit
          title={LESSON_INPUT_OPTIONS[LESSON_TYPES.liveLecture].label}
          titleClassName="hint"
          className="m-b-s"
        >
          {(editableProps) => (
            <div className="row">
              <EditSbatGroupLessonForm
                {...editableProps}
                sbatGroup={sbatGroup}
                value={discussion}
                label={LESSON_INPUT_OPTIONS[LESSON_TYPES.liveLecture].label}
              />
              <Tappable
                className="link m-b-s"
                href={`/meetings/permalink/${sbatGroup.meeting.id}`}
                noHighlight
                target="_blank"
              >
                Meeting link
              </Tappable>
            </div>
          )}
        </EditableSection>
      </>
    );
  }

  return null;
}

export default Discussion;
